module.exports = __webpack_public_path__ + "img/moving.8280e7aa.svg";